import * as core from '../../../../../../../core'

import { query } from './create-proposal-modal.query'

export const RESOURCE = {
  payload: {
    alias: 'create.proposal.modal',
    description: 'Modal used to create proposals',
    name: 'Crate Proposal Modal',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
